export const SET_FIRST_NAME = 'workers:set-first-name';
export const SET_LAST_NAME = 'workers:set-last-name';
export const SET_EMAIL = 'workers:set-email';
export const SET_CELLPHONE = 'workers:set-cellphone';
export const SET_CO = 'workers:set-co';
export const SET_STREET = 'workers:set-street';
export const SET_ZIP = 'workers:set-zip';
export const SET_CITY = 'workers:set-city';
export const SET_COUNTRY = 'workers:set-country';
export const SET_PROFESSION_TITLE = 'workers:set-profession-title';
export const SET_SOCIAL_SECUTIRY_NUMBER = 'workers:set-social-security-number';
export const SET_ACCOUNT_CLEARING_NUMBER = 'workers:set-account-clearing-number';
export const SET_ACCOUNT_NUMBER = 'workers:set-account-number';
export const SET_BANKGIRO = 'workers:set-bankgiro';
export const SET_POSTGIRO = 'workers:set-postgiro';
export const SET_BIC = 'workers:set-bic';
export const SET_IBAN = 'workers:set-iban';
export const SET_INTERNATIONAL_ACCOUNT = 'workers:set-international-account';
export const SET_SHOW_NAME_IN_NETWORK = 'workers:set-show-name-in-network';
export const SET_SAVE_VACATION_PAY = 'workers:set-save-vacation-pay';
export const SET_SAVE_ITP = 'workers:set-save-itp';
export const SET_ITP_RATE = 'workers:set-itp-rate';
export const SET_DISPLAY_HSD = 'workers:set-display-hsd';
export const SET_PREFFERED_PAYMENT_TYPE_ID = 'workers:set-preffered-payment-type-id';
export const SET_RECEIVE_SMS_NOTIFICATIONS = 'workers:set-receive-sms-notifications';
export const SET_RECEIVE_EMAIL_NOTICATIONS = 'workers:set-receive-email-notifications';
export const SET_NOTIFICATION_LANGUAGE = 'workers:set-notification-language';
export const SET_REMOTE_ID = 'workers:set-remote-id';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/workers/action-types.js
 **/